module.exports = __webpack_public_path__ + "img/breaking_barriers.b1017ac9.svg";